/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentModelSummary {
    getFixupPrototypeFunction() { return AIAgentModelSummary.fixupPrototype; }

    static newInstance(model: Partial<AIAgentModelSummary>): AIAgentModelSummary {
        let obj = Object.assign(new AIAgentModelSummary(), model);
        AIAgentModelSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentModelSummary>): AIAgentModelSummary {
        if (!model) return null;
        return AIAgentModelSummary.newInstance(<AIAgentModelSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentModelSummary) {
        if (!obj) return;

        models.AIAgentModelSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentModelSummary): boolean {
        Object.setPrototypeOf(obj, AIAgentModelSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.spans === undefined) {
            this.spans = 0;
        }
        if (this.input_tokens === undefined) {
            this.input_tokens = 0;
        }
        if (this.output_tokens === undefined) {
            this.output_tokens = 0;
        }
        if (this.total_tokens === undefined) {
            this.total_tokens = 0;
        }
        if (this.input_cost === undefined) {
            this.input_cost = 0;
        }
        if (this.output_cost === undefined) {
            this.output_cost = 0;
        }
    }

    /**
     * Model identifier recorded on the span
     */
    model_id: string;

    /**
     * Model display name recorded on the span
     */
    model_name: string;

    /**
     * Distinct span count for this model in the time range
     */
    spans: number;

    /**
     * Sum of input tokens for this model in the time range
     */
    input_tokens: number;

    /**
     * Sum of output tokens for this model in the time range
     */
    output_tokens: number;

    /**
     * Sum of total tokens for this model in the time range
     */
    total_tokens: number;

    /**
     * Sum of input token cost for this model in the time range
     */
    input_cost: number;

    /**
     * Sum of output token cost for this model in the time range
     */
    output_cost: number;

}
